
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/branches",
      function () {
        return require("private-next-pages/branches/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/branches"])
      });
    }
  